import styled from '@emotion/styled';
import { Avatar } from '@mui/material';

import { theme } from '@/theme';

export const StyledNavAvatar = styled(Avatar)`
    background-color: ${theme.palette.brand.main};
    height: 3.2rem;
    width: 3.2rem;
    font-size: ${theme.typography.h5.fontSize};
    font-weight: ${theme.typography.h5.fontWeight};
    letter-spacing: -0.1rem;
    line-height: 0;
    cursor: pointer;
`;
